
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Lenis as ReactLenis } from '@studio-freight/react-lenis';
import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail';
import About from './components/About/About';
import Research from './components/Research/Research';
import ContactUs from './components/ContactUs/ContactUs';
import InteractiveBackground from './components/InteractiveBackground/InteractiveBackground';
import './App.css';

// ScrollToTop component to handle route changes
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

const AppContent = () => {
    return (
        <ReactLenis root>
            <div className="app-container">
                <InteractiveBackground />
                <Navbar />

                <main style={{ position: 'relative', zIndex: 1 }}>
                    <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/blog/:id" element={<BlogDetail />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/research" element={<Research />} />
                        <Route path="/contactus" element={<ContactUs />} />
                    </Routes>
                </main>
            </div>
        </ReactLenis>
    );
}

const App = () => {
    return (
        <Router>
            <AppContent />
        </Router>
    );
};

export default App;
